module.exports = __webpack_public_path__ + "group.svg?800054bb14c5545cb4c9e1098d2be8dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group.svg
// module id = 120
// module chunks = 0